module.exports = __webpack_public_path__ + "static/media/29.d826d6b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/29.jpg
// module id = 719
// module chunks = 0